import { Component, OnInit, SimpleChanges, OnChanges, HostListener, ViewChild } from '@angular/core';
import { MainService } from '../services/delavci/main.service';
import { Router, NavigationEnd } from '@angular/router';
import { User } from '../models/User';
import { MonitorService } from '../services/delavci/monitor/monitor.service';
import { LoginPartnerService } from '../services/partner/login-partner/login-partner.service';
import { Partner } from '../models/Partner';
import { Constants } from '../utils/constants';
import { SaleService } from '../services/partner/sale.service';
import { AppConfigServiceService } from '../services/app-config-service.service';
import { HelpdeskService } from '../services/delavci/helpdesk.service';
import { RepositoryService } from '../services/repository.service';
import { HelpersService } from '../services/shared/helpers.service';
import { SideNavBarComponent } from '../side-nav-bar/side-nav-bar.component';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})
export class NavigationComponent implements OnInit, OnChanges {
  public isCollapsed: boolean = false;
  public href: string;
  public currentUser: User;
  public currentPartner: Partner;
  public nastavitveClicked = true;
  public loginDelavec = false;
  public loginPartner = false;
  public verzija = 'Verzija: 5.2.4';
  public assets;
  public analizaFilterClicked = false;
  public urediHelpdeskFilterClicked = false;
  public luminaPOSFilterClicked = false;
  public odlagalisceFilterClicked = false;
  public prodajaSettingsClicked;
  public showProdajaFilters = false;
  public showProdajaUreDropdown = false;
  public periodSubscription = "1";
  deferredPrompt: any;
  showButton: boolean;
  public helpdeskFilterToggle = true;
  public hasMessage: boolean;
  public message:number;
  constructor(private mainService: MainService, private monitorService: MonitorService, private loginPartnerService: LoginPartnerService,
     private router: Router, public MY_CONSTANTS: Constants, private saleService: SaleService,
     private appConfigService: AppConfigServiceService, private helpdeskService: HelpdeskService, private repositoryService: RepositoryService,
     private helpersService: HelpersService , private configService: AppConfigServiceService) {
      this.helpersService.hasMessage$.subscribe((hasMessage) => {
        this.hasMessage = hasMessage;
      });
      this.helpersService.message.subscribe((message) => {
        this.message = message;
      });
    this.mainService.currentHref.subscribe(message => {
      this.href = message;
      if(this.href.startsWith('/prodaja/izbira/')){
        this.showProdajaFilters = true;

      } else {
        this.showProdajaFilters = false;
      }
      if(this.href.startsWith('/prodaja/izbira/ure')){
        this.showProdajaUreDropdown = true;

      } else {
        this.showProdajaUreDropdown = false;
      }
    });
    this.mainService.prodajaSettingsBool.subscribe( data => {
      this.prodajaSettingsClicked = data;
    });
    this.mainService.currentUser.subscribe(then => this.ngOnInit());

    this.loginPartnerService.currentPartner.subscribe(then => this.ngOnInit());

    this.helpdeskService.currentPeriodTab.subscribe( data => {
      this.periodSubscription = data;
    });
  }
  @ViewChild('sideNavBar', { static: false }) sideNavBar: SideNavBarComponent;

  toggleSidebar() {
    this.sideNavBar.toggleSidebar();
  }
  ngOnInit() {
    
    this.appConfigService.configWhichLogin;
    this.helpdeskService.changeHelpdeskFilterToggle(this.helpdeskFilterToggle.toString());
    if(!this.saleService.currentSaleFilter) {
      this.saleService.changeSaleFilter('SALEVALUE');
    }
    this.assets = this.appConfigService.apiAssets;
    if (this.mainService.currentUserValue) {
      this.loginDelavec = true;
      this.currentUser = this.mainService.currentUserValue;
    } else {
      this.loginDelavec = false;
    }

    if (this.loginPartnerService.currentPartnerValue) {
      this.loginPartner = true;
      this.currentPartner = this.loginPartnerService.currentPartnerValue;
    } else {
      this.loginPartner = false;
    }

    if(!localStorage.getItem('periodTab')) {
      this.helpdeskService.changePeriodTab("1");
    }
    this.mainService.analizaFilterBool.subscribe( bool => {
      this.analizaFilterClicked = bool;
    });


  }


  toMessage(message){
    localStorage.setItem("lastTaskId", JSON.stringify(message));
    this.router.navigate(["/uredi-task/" + message], { queryParams: { zavihek: 'messages'} });
  }

  showNavbar() {
    if (this.mainService.currentUserValue || this.loginPartnerService.currentPartnerValue) {
      return true;
    }
    return false;
  }
  showNoNewMessagesPrompt(){
    alert("Ni novih sporočil");
  }
  onLogout() {
    this.sideNavBar.closeSidebar();
    if(this.loginDelavec) {
      
      this.mainService.logout();
      this.loginDelavec = false;
      this.router.navigate(['/login']);
    }

    if (this.loginPartner) {
      this.loginPartnerService.logout();
      this.loginPartner = false;
      this.router.navigate(['/login-partner']);
    }
  }

  onCollapse() {
    if (this.isCollapsed === false) {
      this.isCollapsed = true;
    } else {
      this.isCollapsed = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    console.log(changes);
  }

  onNastavitve() {
    if (this.nastavitveClicked) {
      this.mainService.changeNastavitveBool(this.nastavitveClicked);
      this.nastavitveClicked = false;
    } else {
      this.mainService.changeNastavitveBool(this.nastavitveClicked);
      this.nastavitveClicked = true;
    }
  }


  onSaleFilter(type) {
    this.saleService.changeSaleFilter(type);
  }

  onAnaliza() {
    if (!this.analizaFilterClicked) {
      console.log('true')
      this.analizaFilterClicked = true;
      this.mainService.changeAnalizaFilterBool(this.analizaFilterClicked);
    } else {
      console.log('false')
      this.analizaFilterClicked = false;
      this.mainService.changeAnalizaFilterBool(this.analizaFilterClicked);
    }
  }


  onSaleSettings() {
    if(this.prodajaSettingsClicked) {
      this.prodajaSettingsClicked = false;
      this.mainService.changeProdajaSettingsBool(false);
    } else {
      this.prodajaSettingsClicked = true;
      this.mainService.changeProdajaSettingsBool(true);
    }
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onbeforeinstallprompt(e) {
    console.log(e);
    // Prevent Chrome 67 and earlier from automatically showing the prompt
    e.preventDefault();
    // Stash the event so it can be triggered later.
    this.deferredPrompt = e;
    this.showButton = true;
  }

  addToHomeScreen() {
    this.deferredPrompt.prompt();
        this.deferredPrompt.userChoice.then(result => {
            if (result.outcome == 'dismissed') {
              console.log('User dismissed the A2HS prompt');
            } else {
              console.log('User accepted the A2HS prompt');
            }
        });
  }

  selectPeriod(period) {
    this.helpdeskService.changePeriodTab(period);
  }

  onHelpdeskFilterToggle() {
    this.helpdeskFilterToggle = !this.helpdeskFilterToggle;
    this.helpdeskService.changeHelpdeskFilterToggle(this.helpdeskFilterToggle.toString());
  }

  onHelpdeskQuickRefresh(){
    window.location.reload();
  }

  onOdlagalisce() {
    if (!this.odlagalisceFilterClicked) {
      this.odlagalisceFilterClicked = true;
      this.mainService.changeOdlagalisceFilterBool(this.odlagalisceFilterClicked);
    } else {
      this.odlagalisceFilterClicked = false;
      this.mainService.changeOdlagalisceFilterBool(this.odlagalisceFilterClicked);
    }
  }

  onUrediHelpdeskFilter() {
    if (!this.urediHelpdeskFilterClicked) {
      this.urediHelpdeskFilterClicked = true;
      this.helpdeskService.changeUrediHelpdeskFilterBool(this.urediHelpdeskFilterClicked);
    } else {
      this.urediHelpdeskFilterClicked = false;
      this.helpdeskService.changeUrediHelpdeskFilterBool(this.urediHelpdeskFilterClicked);
    }
  }

  onLuminaPOS() {
    if (!this.luminaPOSFilterClicked) {
      this.luminaPOSFilterClicked = true;
      this.repositoryService.changeLuminaPOSFilter(this.luminaPOSFilterClicked);
    } else {
      this.luminaPOSFilterClicked = false;
      this.repositoryService.changeLuminaPOSFilter(this.luminaPOSFilterClicked);
    }
  }
}
